import Layout from "@/components/Layout";
import ProviderListing from "@/components/ProviderListing";

const Providers = () => {
  return (
    <Layout>
      <ProviderListing
        title="Professionals on WellFitly"
        browserTitle="Professionals on WellFitly"
      />
    </Layout>
  );
};

export default Providers;
